import { Company, Invitation } from 'src/types/data';

/**
 * Add a new invitation to the list.
 */
export const addInvitation = (invitations: Invitation[], newInvitation: Invitation): Invitation[] => 
  [...invitations, newInvitation];

/**
 * Update an existing invitation in the list.
 */
export const updateInvitation = (invitations: Invitation[], updatedInvitation: Invitation): Invitation[] => 
  invitations.map((invitation) =>
    invitation.id === updatedInvitation.id ? updatedInvitation : invitation
  );

/**
 * Remove an invitation by ID from the list.
 */
export const removeInvitation = (invitations: Invitation[], invitationId: number): Invitation[] => 
  invitations.filter((invitation) => invitation.id !== invitationId);

/**
 * Updates a company in the list based on its ID with partial data.
 * @param companies - The current list of companies.
 * @param updatedCompany - Partial company data to update.
 * @returns The updated list of companies.
 */
export const updateCompanyInList = (
  companies: Company[],
  updatedCompany: Partial<Company> & { id: number }
): Company[] =>
  companies.map((company) =>
    company.id === updatedCompany.id ? { ...company, ...updatedCompany } : company
  );


/**
 * Filters companies based on selected IDs.
 * @param companies - The current list of companies.
 * @param selectedIds - The IDs of selected companies.
 * @returns The filtered list of companies.
 */
export const filterCompaniesByIds = (companies: Company[], selectedIds: number[]): Company[] => 
  companies.filter((company) => selectedIds.includes(company.id));

/**
 * Removes a company from the list based on its ID.
 * @param companies - The current list of companies.
 * @param companyId - The ID of the company to remove.
 * @returns The updated list of companies.
 */
export const removeCompanyFromList = (companies: Company[], companyId: number): Company[] => 
  companies.filter((company) => company.id !== companyId);
